
import { useState, useEffect, useContext } from "react";
import { Row, message, Col, Breadcrumb, Badge, Dropdown, Button, Card, Input, Image, Form, Modal, Upload, TextArea } from "antd";
import useRequest from "../../hooks/useRequest";
import { AuthContext } from "../../context/AuthContext";
import { KeyOutlined, LogoutOutlined, UserOutlined, SettingOutlined ,QuestionCircleFilled} from "@ant-design/icons";
import apiPath from "../../constants/apiPath";
import { ShowToast, Severty } from "../../helper/toast";
import SingleImageUpload from "../../components/SingleImageUpload";
import { NavLink, Link } from "react-router-dom";
import notfound from "../../assets/images/not_found.png";
const { confirm } = Modal;

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name, onPress }) {

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const [visible, setVisible] = useState(false);

  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);

  const [appSetting, setAppSetting] = useState({});
  const [breadcrumb, setBreadcrumb] = useState(name?.split('/') ?? []);
  const [appSettingSelected, setAppSettingSelected] = useState();
  const [appSettingVisible, setAppSettingVisible] = useState(false);

  const { request } = useRequest()
  const [refresh, setRefresh] = useState(false)
  const { logout } = useContext(AuthContext)
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const items = [
    {
      label: 'Edit Profile',
      key: '1',
      icon: <UserOutlined />,
      danger: true,
    },
    {
      label: 'Change Password',
      key: '2',
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: 'App Setting',
      key: '4',
      icon: <SettingOutlined />,
      danger: true,
    },
    {
      label: 'Logout',
      key: '3',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ]; 

  const showDeleteConfirm = (record) => {
    setTimeout(() => {
      confirm({
        okText: 'Logout',
        okType: 'danger',
        icon: <QuestionCircleFilled />,
        cancelText: 'Cancel',
        content: <Button >Are you sure you want to logout ?</Button>,
        onOk() {
          logout();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);
  };

  const handleMenuClick = (e) => {
    if (e.key == 2) {
      setVisible(true)
    }
    if (e.key == 1) {
      setProfileVisible(true)
    }
    if (e.key == 4) {
      setAppSettingVisible(true)
    }
    if (e.key == 3) {
      showDeleteConfirm()
    }
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const onCreate = (values) => {
    const { old_password, new_password } = values
    const payload = {}
    if (!old_password || !new_password) return ShowToast('Please enter password ', Severty.ERROR)
    setLoading(true)
    payload.new_password = new_password
    payload.old_password = old_password
    request({
      url: apiPath.changePassword,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          setVisible(false)
          logout()
        } else {
          ShowToast(data.message, Severty.ERROR)

        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };

  useEffect(() => {

    setBreadcrumb(name?.split('/') ?? [])
  }, [name])
  useEffect(() => {
    request({
      url: apiPath.profile,
      method: 'GET',
      onSuccess: (data) => {
        setProfile(data.data)
        setSelected(data.data)
      },
    })
    request({
      url: apiPath.getAppSetting,
      method: 'GET',
      onSuccess: (data) => {
        setAppSetting(data.data)
        setAppSettingSelected(data.data)
      },
    })
  }, [refresh])

  return (
    <>

      <Row gutter={[24, 0]}>
        <Col span={24} xs={18} md={10} className="breadcrumbMain">
          
          <h3 style={{ fontWeight: '600'}}>
            Welcome {profile?.user_type} <span style={{ textTransform: 'capitalize' }}> <i>{' - ' + profile?.name}</i> </span>
          </h3>

          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Home</NavLink>
            </Breadcrumb.Item>

            {
              breadcrumb.map((item, index) =>
                <Breadcrumb.Item key={item} style={{ textTransform: "capitalize" }}>
                  {item}
                </Breadcrumb.Item>
              )
            }
          </Breadcrumb>
        </Col>


        <Col span={24} xs={24} sm={14} className="text-right header-control">
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          <div className="profileDropdownMain">
            <Dropdown menu={menuProps}>
              <div className="font-semibold text-right ant-dropdown-trigger ant-dropdown-open">
                <div className="userName">{profile ? profile.name : "Administrator"}</div>
                <div className="userEmail">{profile ? profile.email : "admin@noreply.com"} </div>
              </div>
            </Dropdown>
            <Image
              src={profile ? profile.image : 'noimage'}
            />
          </div>
        </Col>
      </Row>

      {profileVisible && <EditProfile show={profileVisible} hide={() => { setProfileVisible(false) }} data={selected} refresh={() => setRefresh(prev => !prev)} />}
      {appSettingVisible && <AppSetting show={appSettingVisible} hide={() => { setAppSettingVisible(false) }} data={appSettingSelected} refresh={() => setRefresh(prev => !prev)} />}

      <Modal
        visible={visible}
        title="Change password"
        okText="Ok"
        onCancel={() => {
          setVisible(false);
        }}
        onOk={handleCreate}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Old Password"
            name="old_password"
            hasFeedback
            rules={[
              { required: true, message: "Please enter the old password!" },
            ]}
          >
            <Input.Password placeholder="Enter Old Password" />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            dependencies={['old_password']}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the new password!" },
              { pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/), message: "New password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('old_password') === value) {
                    return Promise.reject(new Error('Old password & new password must be different!'));
                  }
                  return Promise.resolve();

                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter New Password" />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirm_new_password"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the confirm password!" },
              { pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/), message: "Confirm password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Confirm password & password does not match!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter Confirm Password" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}


const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)
  const [image, setImage] = useState([]);
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/gif"]

  const handleImage = (data) => {
    setImage(data[0].url);
  }

  useEffect(() => {
    if (!data) return
    form.setFieldsValue({ ...data })
    if (data.image != undefined) {
      setImage(data.image)
    } else {
      setImage([notfound])
    }
  }, [data])


  const onEditProfile = (values) => {
    const payload = {
      ...values,
      image : image
    }
    setLoading(true)
    request({
      url: apiPath.updateProfile,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          hide()
          refresh()
        } else {
          ShowToast(data.message, Severty.ERROR)

        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };

  return (
    <Modal
      visible={show}
      width={750}
      title={`${data ? 'Edit Profile' : ''}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={12}>
            <Form.Item label="Name" name="name"
              rules={[
                { required: true, message: "Please enter the name!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed" }
              ]}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Email Address" name="email"
              rules={
                [
                  {
                    type: 'email', message: 'The input is not valid E-mail!',
                  },
                  { required: true, message: "Please enter the email!" }
                ]}
            >
              <Input placeholder="Enter Email Address" disabled />
            </Form.Item>
          </Col>
          
          <Col span={24}>
            <Form.Item label="Upload Profile" name="image">
              
              <SingleImageUpload value={image} fileType={FileType} imageType={'picture'} btnName={'Profile'} onChange={(data) => handleImage(data)} />

              {image && <div className="mt-3"> <img width={100} src={image} /> </div>}

            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export const AppSetting = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!data) return
    form.setFieldsValue({ ...data });
  }, [data])


  const onAppSetting = (values) => {
    setLoading(true)
    request({
      url: apiPath.updateAppSetting,
      method: 'POST',
      data: values,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          hide()
          refresh()
        } else {
          ShowToast(data.message, Severty.ERROR)
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };

  return (
    <Modal
      width={1200}
      visible={show}
      title={`${data ? 'Update App Setting' : ''}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >

      <Form id="create" form={form} onFinish={onAppSetting} layout="vertical">
        <Row gutter={{ xs: [0,16], md: [16,0] }}>

          <Col span={24} md={12}>
            <Card title="Android Details">
              <Col span={24}>
                <Form.Item label="App Store URL" name="app_store_url"
                  rules={[
                    { required: true, message: "Please enter the app store URL!" },
                  ]}
                >
                  <Input placeholder="Enter App Store URL" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item label="Version" name="android_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter Android Version" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item label="Share Content" name="android_share_content"
                  rules={[
                    { required: true, message: "Please enter the share content!" },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share Android Content"
                  />

                </Form.Item>
              </Col>
            </Card>
          </Col>


          <Col span={24} md={12}>
            <Card title="IOS Details">

              <Col span={24} className="">
                <Form.Item label="Play Store URL" name="play_store_url"
                  rules={[
                    { required: true, message: "Please enter the play store URL!" },
                  ]}
                >
                  <Input placeholder="Enter Play Store URL" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item label="Version" name="ios_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter IOS Version" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item label="Share Content" name="ios_share_content"
                  rules={[
                    { required: true, message: "Please enter the share content!" },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share IOS Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>

        </Row>

      </Form>
    </Modal>
  )
}

export default Header;
